<script>
    import {HasOnlySpaces} from "../../../Common/Functions";

    export let recipe;
    export let thumbnail;
    let loaded = true;

    function getYieldHtml() {
        let exp = recipe.yield.split(' ')
        let result = '';
        result = '<dd itemprop="recipeYield">' + recipe.yield + '</dd>';
        result += '<dt></dt>';

        let firstIndex = 0;
        if (exp.length && exp.length > 1) {
            if (HasOnlySpaces(exp[firstIndex])) firstIndex += 1;
            result = '';
            result += '<dd itemprop="recipeYield">' + exp[firstIndex] + '</dd>';
            let dt_result = '';
            for (let i = 0; i < exp.length; i++) {
                let word = exp[i];
                if (i !== firstIndex) {
                    dt_result += word + " ";
                }
            }

            result += '<dt>' + dt_result + '</dt>';

        }
        return result;
    }

</script>

<div class="fancybox-outer recipe-modal" id="recipe-modal">
    <div class="fancybox-inner recipe-modal">
        <!-- Content Section -->
        <section class="hub-item-recipe-overlay">
            <div class="recipe-wrapper inner">
                <div itemscope="" itemtype="http://schema.org/Recipe">

                    <!--Recipe Stats Section-->
                    <div class="recipe-image-wrapper">
                        <img alt={recipe.title} src="{thumbnail}"
                             class="recipe-image" itemprop="image">
                        <ul class="recipe-stats grid">
                            <li class="grid-item">
                                <dl>
                                    <dd>
                                        <meta content="PT15M" itemprop="prepTime">
                                        {recipe.prepTime}
                                    </dd>
                                    <dt>Prep Time</dt>
                                </dl>
                            </li>
                            <li class="grid-item">
                                <dl>
                                    <dd>
                                        <meta content="PT30M" itemprop="cookTime">
                                        {recipe.cookTime}
                                    </dd>
                                    <dt>Cook Time</dt>
                                </dl>
                            </li>
                            <li class="grid-item">
                                <dl>
                                    {@html getYieldHtml()}
                                </dl>
                            </li>
                        </ul>
                    </div>
                    <div class="main-recipe-content">

                        <!--Print and Mail Section-->
                        <ul class="recipe-icons">
                            <li>
                                <a id="print-icon" data-ga-label="{recipe.title}"
                                   data-ga-category="Recipe Print" data-capture="click" target="_blank"
                                   href="/print?recipeId={recipe.id}"><i
                                        class="fa fa-print"></i></a>
                            </li>
                            <li>
                                <a data-ga-label="{recipe.title}" data-ga-action="Email"
                                   data-ga-category="Recipe Share" data-capture="click"
                                   href="mailto:?subject=A Hungry Jack Recipe Just For You&amp;body=I saw this recipe on HungryJack.com. Hope you enjoy! You can view the recipe by clicking the link below or copying it into your browser's address bar.%0D%0A%0D%0A{recipe.url}"
                                   id="email-icon"><i class="fa fa-envelope"></i></a>
                            </li>
                        </ul>
                        <h1 itemprop="name">
                            <span>{recipe.title}</span>
                        </h1>
                        <!-- Social icons-->
                        <ul class="social-icons">
                            <li data-ga-label="{recipe.title}" data-ga-action="Pinterest" data-ga-category="Recipe Share" data-capture="click" tabindex="0" class="pinterest-container">
                                <a data-pin-color="gray" data-pin-do="buttonPin" href="https://www.pinterest.com/pin/create/button/?url={recipe.url}&media={recipe.image}&description={recipe.title}">
                                    <img alt="Pinterest" src="//assets.pinterest.com/images/pidgets/pinit_fg_en_rect_gray_20.png">
                                </a>
                            </li>
                            <li>
                                <img data-ga-label="{recipe.title}"
                                     data-ga-category="Recipe Share"
                                     data-share-image="{recipe.image}"
                                     data-share-text="{recipe.title}"
                                     data-share-url="" tabindex="0" alt="Share"
                                     src="/wp-content/themes/hungryjack/images/global/btn_fb_share.jpg"
                                     class="fb-share">
                            </li>
                        </ul>
                        <hr>

                        {@html recipe.content}
                    </div>

                    <!-- Nutrition Info Section -->
                    <ul class="nutritional-info collapsable-list">
                        <li>
                            <section class="wrapper">
                                <header>
                                    <h2>Nutritional Information Per Serving</h2>
                                </header>
                                <div class="collapsable-content">
                                    {@html recipe.nutrition}
                                </div>
                            </section>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
    </div>
</div>

<style>
    .fancybox-outer#recipe-modal {
        max-width: 1200px;
        max-height: 800px;
    }
</style>